import request from '@teetsh/app/src/utils/request';
import { useState } from 'react';

interface Props {
  file: any;
  onStart: () => void;
  onFinished: () => void;
  onError: () => void;
}

type UploadResponse = {
  data: any;
  meta: any;
};
export default async function uploadAttachment(props: Props) {
  const { file, onStart, onFinished, onError } = props;

  onStart();

  const requestURL = '/eleves/upload-file';
  const formData = new FormData();
  formData.append('data', file);
  try {
    const res: UploadResponse = await request(requestURL, {
      method: 'POST',
      body: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res;
  } catch (e) {
    onError();
    throw e;
  } finally {
    onFinished();
  }
}

export function useUploadAndParseElevesFile() {
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const upload = ({ file }: { file: any }) =>
    uploadAttachment({
      file,
      onStart: () => setIsUploading(true),
      onFinished: () => setIsUploading(false),
      onError: () => setIsUploading(false),
    });

  return {
    upload,
    isUploading,
  };
}
